import React from 'react'
import './style.css'
import { map } from 'lodash'
import { upgradeSubscription } from '~/redux/user/helpers'
import PopupPlan from '~/components/PopupPlan'
import popup from '../../popup'
import connect from "~/tools/connect";
import userStore from "~/redux/user/store"

class UpgradeSubscription extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: null,
      processing: false,
      fields: props.args.fields
    }
  }

  render() {
    return(
      <div className={`upgrade-subscription centered opaque padded ${this.state.processing ? 'processing' : ''}`}>
        <h1>{this.state.fields.upgradePlanHeaderLabel}</h1>
        <p>{this.state.fields.upgradeSubscriptionSelectPlanHeader}</p>
        <div className="upgrade-plans-container">
          { this.renderPlans() }
        </div>
        { this.state.alert && <div className="alert"> { this.state.alert } </div> }
        <div className="legal-texts">
           <p>{this.state.fields.upgradePlanWarningMessage}</p>
         </div>
      </div>
    )
  }

  renderPlans() {
    const plans = this.state.user.subscription.plans

    if (plans.length > 0) {
      return map(plans, data => {
        return (
          <PopupPlan
            plan={ data }
            key={ data.id }
            selected={ this.state.selected === data.id }
            buttonText={this.state.fields.upgradePlanButtonText}
            hideFreeTrialText={ true }
            onClick={ () => this.changePlan(data) }/>
        )
      })
    } else {
      return <div>{this.state.fields.upgradeSubscriptionNoPlansMessage}</div>
    }
  }

  changePlan(plan) {
    if (plan.id !== this.state.selected)
      return this.setState({ selected: plan.id })

    var paymentHandler = this.state.user.subscription.subscriptionInfo.paymentHandler.toLowerCase()
    this.setState({ processing: true })
    upgradeSubscription(plan, paymentHandler)
      .then( popup.hide )
      .catch(e => {
        var error = ((e.response || {}).data || {}).code
        this.alert(this.state.fields[error] || "We are unable to upgrade your subscription.")
      })
      .then(_ => { this.setState({ processing: false }) })
  }

  alert(msg) {
    this.setState({ alert: msg })
    setTimeout(_ => this.setState({ alert: null }), 4000)
  }
}

connect(UpgradeSubscription, (state) => ({ user: state.user }), userStore)

export default UpgradeSubscription;